module.exports = __webpack_public_path__ + "img/p2-2.66e6ae52.png";